import { memo, useState } from 'react';
import { useNavigate } from 'react-router';

import type { CustomBreadcrumbProps } from '../CustomBreadcrumb';
import { CustomBreadcrumb } from '../CustomBreadcrumb';
import type { BreadCrumbDetails } from '../CustomBreadcrumb/CustomBreadcrumb.types';
import type { ExitConfirmationModalProps } from '../Modals/ExitConfirmationModal';
import { ExitConfirmationModal } from '../Modals/ExitConfirmationModal';

interface CustomBreadcrumbWithExitConfirmationProps extends CustomBreadcrumbProps {
  isEnabledModifiedModal?: boolean;
  modal?: Pick<ExitConfirmationModalProps, 'className' | 'description' | 'title'>;
}

const CustomBreadcrumbWithExitConfirmation = ({
  breadcrumbsDetails,
  isEnabledModifiedModal,
  isIncludedDefaultNav = true,
  isIncludedEservices = true,
  modal,
}: CustomBreadcrumbWithExitConfirmationProps) => {
  const [isShowModifiedModal, setIsShowModifiedModal] = useState(false);
  const [clickedBreadcrumb, setClickedBreadcrumb] = useState<BreadCrumbDetails | undefined>(undefined);
  const navigate = useNavigate();

  const onOkClick = () => {
    setIsShowModifiedModal(false);
    if (clickedBreadcrumb) {
      const { customOnClick, path } = clickedBreadcrumb;
      if (customOnClick) {
        customOnClick();
        return;
      }
      if (path) {
        navigate({
          pathname: path,
        });
      }
    }
  };
  const onCancelClick = () => {
    setIsShowModifiedModal(false);
  };

  return (
    <>
      <CustomBreadcrumb
        breadcrumbsDetails={breadcrumbsDetails?.map((breadcrumbs) => ({
          ...breadcrumbs,
          customOnClick: isEnabledModifiedModal
            ? () => {
                setIsShowModifiedModal(true);
                setClickedBreadcrumb(breadcrumbs);
              }
            : undefined,
          path: isEnabledModifiedModal ? undefined : breadcrumbs.path,
        }))}
        isIncludedDefaultNav={isIncludedDefaultNav}
        isIncludedEservices={isIncludedEservices}
      />
      <ExitConfirmationModal
        onCancelClick={onCancelClick}
        onOkClick={onOkClick}
        open={isShowModifiedModal}
        {...modal}
      />
    </>
  );
};
export default memo(CustomBreadcrumbWithExitConfirmation);
